import CompanyList from '@/components/Company/CompanyList'
import CompanyForm from '@/components/Company/CompanyForm'
import CompanyDetail from '@/components/Company/CompanyDetail'

let CompanyRouter = [{
  path: '/company',
  name: 'CompanyList',
  component: CompanyList,
  meta: {
    title: 'Entreprises',
    requiresAuth: true,
    authorizations: ['company_index', 'desktop_access']
  }
}, {
  path: '/company/new',
  name: 'CompanyNew',
  component: CompanyForm,
  meta: {
    title: 'Nouvelle entreprise',
    requiresAuth: true,
    authorizations: ['company_new', 'desktop_access']
  }
}, {
  path: '/company/:id/edit',
  name: 'CompanyEdit',
  component: CompanyForm,
  meta: {
    title: 'Modifier une entreprise',
    requiresAuth: true,
    authorizations: ['company_edit', 'desktop_access']
  }
}, {
  path: '/company/:id',
  name: 'CompanyDetail',
  component: CompanyDetail,
  meta: {
    title: 'Fiche entreprise',
    requiresAuth: true,
    authorizations: ['company_show', 'desktop_access']
  }
}]

export default CompanyRouter



// WEBPACK FOOTER //
// ./src/components/Company/router.js